"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleOnlineTag = void 0;
/* eslint-disable no-underscore-dangle */
const core_1 = require("@angular/core");
const service_1 = __importDefault(require("../translations/service"));
const api_1 = require("../../../@shared-types/api");
let VehicleOnlineTag = class VehicleOnlineTag {
    constructor(translationService) {
        this.translationService = translationService;
        /** true: online, active | false: online, deactivated | null: not online */
        this.onlineState = null;
        this.hover = false;
        this.hoverContent = '';
        this.previousVehicle = '';
        this.setOnlineState = () => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
            this.onlineState = null;
            if ((_a = this.vehicle.apiData) === null || _a === void 0 ? void 0 : _a.currentlyExporting) {
                this.onlineState = 'exporting';
                return;
            }
            if ((_c = (_b = this.vehicle.apiData) === null || _b === void 0 ? void 0 : _b.exportErrors) === null || _c === void 0 ? void 0 : _c.length) {
                this.onlineState = 'error';
                return;
            }
            if (((_e = (_d = this.vehicle.apiData) === null || _d === void 0 ? void 0 : _d.MOBILE_SELLER) === null || _e === void 0 ? void 0 : _e.length)
                || ((_g = (_f = this.vehicle.apiData) === null || _f === void 0 ? void 0 : _f.AUTOSCOUT24) === null || _g === void 0 ? void 0 : _g.length)
                || ((_j = (_h = this.vehicle.apiData) === null || _h === void 0 ? void 0 : _h.AWI) === null || _j === void 0 ? void 0 : _j.length)) {
                this.onlineState = 'online';
                const translatedApis = [];
                if ((_l = (_k = this.vehicle.apiData) === null || _k === void 0 ? void 0 : _k.MOBILE_SELLER) === null || _l === void 0 ? void 0 : _l.length) {
                    translatedApis.push(this.translationService.translateExportAPI(api_1.EExportAPI.MOBILE_SELLER));
                }
                if ((_o = (_m = this.vehicle.apiData) === null || _m === void 0 ? void 0 : _m.AUTOSCOUT24) === null || _o === void 0 ? void 0 : _o.length) {
                    translatedApis.push(this.translationService.translateExportAPI(api_1.EExportAPI.AUTOSCOUT24));
                }
                if ((_q = (_p = this.vehicle.apiData) === null || _p === void 0 ? void 0 : _p.AWI) === null || _q === void 0 ? void 0 : _q.length) {
                    translatedApis.push(this.translationService.translateExportAPI(api_1.EExportAPI.AWI));
                }
                this.hoverContent = translatedApis.join('\n');
                if ((_r = this.vehicle.apiData.commonExport) === null || _r === void 0 ? void 0 : _r.deactivated) {
                    this.onlineState = 'deactivated';
                    return;
                }
                /** Check if all accounts are set to `deactivated` = false */
                const mobileDeactivated = ((_s = this.vehicle.apiData.MOBILE_SELLER) === null || _s === void 0 ? void 0 : _s.map((e) => e.deactivated).filter((e) => e).length) || 0;
                const autoScoutDeactivated = ((_t = this.vehicle.apiData.AUTOSCOUT24) === null || _t === void 0 ? void 0 : _t.map((e) => e.deactivated).filter((e) => e).length) || 0;
                const awiDeactivated = ((_u = this.vehicle.apiData.AWI) === null || _u === void 0 ? void 0 : _u.map((e) => e.deactivated).filter((e) => e).length) || 0;
                const commonDeactivated = autoScoutDeactivated + mobileDeactivated + awiDeactivated;
                if (commonDeactivated > 0) {
                    this.onlineState = 'deactivated';
                }
            }
        };
    }
    ngOnChanges() {
        // if (String(this.vehicle._id) === this.previousVehicle) return;
        this.previousVehicle = String(this.vehicle._id);
        this.setOnlineState();
    }
    ngOnInit() {
        this.previousVehicle = String(this.vehicle._id);
        this.setOnlineState();
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], VehicleOnlineTag.prototype, "vehicle", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Boolean)
], VehicleOnlineTag.prototype, "short", void 0);
VehicleOnlineTag = __decorate([
    (0, core_1.Component)({
        selector: 'vehicle-online-tag',
        template: /* html */ `
    <tag
      *ngIf="onlineState !== null"
      [color]="onlineState === 'online' ? 'blue' : onlineState === 'error' ? 'red' : 'orange'"
      (mouseenter)="hover = true;" (mouseleave)="hover = false"
    >
      <ng-template [ngIf]="onlineState === 'online'">
        <span>
          {{ !short ? 'Online' : '' }}
          <i class="fa-solid fa-earth-americas"></i>
        </span>

        <svg style="margin-left: 0.5rem;" class="ab-icon icon vmin-tablet-xl" *ngIf="hoverContent"><use xlink:href="#info-light"></use></svg>
        <div class="hover-content" *ngIf="hover && hoverContent">
          <span>{{ hoverContent }}</span>
        </div>
      </ng-template>

      <ng-template [ngIf]="onlineState === 'deactivated'">
        <span>
          {{ !short ? 'Online (deaktiviert)' : '' }}
          <i class="fa-solid fa-circle-pause"></i>
        </span>

        <svg style="margin-left: 0.5rem;" class="ab-icon icon vmin-tablet-xl" *ngIf="hoverContent"><use xlink:href="#info-light"></use></svg>
        <div class="hover-content" *ngIf="hover && hoverContent">
          <span>{{ hoverContent }}</span>
        </div>
      </ng-template>

      <ng-template [ngIf]="onlineState === 'exporting'">
        <span>
          {{ !short ? 'Wird übertragen' : '' }}
          <i class="fa-solid fa-rotate fa-spin"></i>
        </span>
      </ng-template>

      <ng-template [ngIf]="onlineState === 'error'">
        <span>
          {{ !short ? 'Fehler' : '' }}
          <i class="fa-solid fa-circle-exclamation fa-beat"></i>
        </span>
      </ng-template>
    </tag>
  `,
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof service_1.default !== "undefined" && service_1.default) === "function" ? _a : Object])
], VehicleOnlineTag);
exports.VehicleOnlineTag = VehicleOnlineTag;
